import React from 'react';
import { Empty } from 'antd';

// "Other Settings" tab — placeholder. The previous implementation carried ~90 lines
// of dead client-CRUD logic (fetching a relative /getClients that 404s) behind a
// "Coming soon..." render; removed to avoid confusion.
const GeneralSettings: React.FC = () => (
  <div style={{ padding: 48 }}>
    <Empty description="Other settings — coming soon" />
  </div>
);

export default GeneralSettings;
